import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface FolderOption {
  id: number;
  name: string;
}

interface DocumentCreateDialogData {
  mode: 'folder' | 'document';
  folders: FolderOption[];
  parentFolderId?: number | null;
}

@Component({
  selector: 'app-document-create-dialog',
  templateUrl: './document-create-dialog.component.html',
  styleUrls: ['./document-create-dialog.component.scss']
})
export class DocumentCreateDialogComponent {
  readonly isFolderMode = this.data.mode === 'folder';

  form = this.fb.group({
    name: ['', Validators.required],
    title: ['', Validators.required],
    description: [''],
    folderId: [this.data.parentFolderId ?? null],
    documentType: ['Document'],
    content: [''],
    status: ['Draft']
  });

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DocumentCreateDialogData,
    public dialogRef: MatDialogRef<DocumentCreateDialogComponent>
  ) {}

  save(): void {
    if (this.isFolderMode) {
      this.form.get('name')?.setValidators([Validators.required]);
      this.form.get('title')?.clearValidators();
    } else {
      this.form.get('title')?.setValidators([Validators.required]);
      this.form.get('name')?.clearValidators();
    }

    this.form.get('name')?.updateValueAndValidity();
    this.form.get('title')?.updateValueAndValidity();

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.isFolderMode) {
      this.dialogRef.close({
        name: this.form.value.name,
        description: this.form.value.description,
        parentFolderId: this.form.value.folderId ?? null
      });
      return;
    }

    this.dialogRef.close({
      title: this.form.value.title,
      documentType: this.form.value.documentType,
      content: this.form.value.content,
      status: this.form.value.status,
      folderId: this.form.value.folderId ?? null
    });
  }
}
